import type { Agent } from "../../common/types/Agent";
import type { Booking } from "../../common/types/Booking";
import type { Request } from "../../common/types/Request";

export const mockRequest: Request = {
    id: "test",
    createdAt: {
        seconds: 1640767605,
        nanoseconds: 826000000,
    },
    ticketNumber: 123,
    title: "Request title",
    conversation: "VRUYXcOjYcNGgJkoB8qO",
    member: "c826fd5d46fdf4a78db454ca9f9ac50518d9f223ecb6e9cf0190926deb6290c0",
    status: "new",
    assignedTo: "AlbertineServiceAgent",
    offeringCategory: "dining",
};

export const mockRequestDraft: Request = {
    id: "test",
    createdAt: {
        seconds: 1640767605,
        nanoseconds: 826000000,
    },
    ticketNumber: 123,
    title: "Request title",
    conversation: "VRUYXcOjYcNGgJkoB8qO",
    member: "c826fd5d46fdf4a78db454ca9f9ac50518d9f223ecb6e9cf0190926deb6290c0",
    status: "draft",
    assignedTo: "AlbertineServiceAgent",
    offeringCategory: "dining",
};

export const mockRequestActive: Request = {
    id: "test",
    createdAt: {
        seconds: 1640767605,
        nanoseconds: 826000000,
    },
    ticketNumber: 123,
    title: "Request title",
    conversation: "VRUYXcOjYcNGgJkoB8qO",
    member: "c826fd5d46fdf4a78db454ca9f9ac50518d9f223ecb6e9cf0190926deb6290c0",
    status: "open",
    assignedTo: "AlbertineServiceAgent",
    offeringCategory: "dining",
};

export const mockRequestConfirmed: Request = {
    id: "test",
    createdAt: {
        seconds: 1640767605,
        nanoseconds: 826000000,
    },
    ticketNumber: 123,
    title: "Request title",
    conversation: "VRUYXcOjYcNGgJkoB8qO",
    member: "c826fd5d46fdf4a78db454ca9f9ac50518d9f223ecb6e9cf0190926deb6290c0",
    status: "confirmed",
    assignedTo: "AlbertineServiceAgent",
    offeringCategory: "dining",
};

export const mockRequestClosed: Request = {
    id: "test",
    createdAt: {
        seconds: 1640767605,
        nanoseconds: 826000000,
    },
    ticketNumber: 123,
    title: "Request title",
    conversation: "VRUYXcOjYcNGgJkoB8qO",
    member: "c826fd5d46fdf4a78db454ca9f9ac50518d9f223ecb6e9cf0190926deb6290c0",
    status: "closed",
    assignedTo: "AlbertineServiceAgent",
    offeringCategory: "dining",
    memberRating: 4,
    memberFeedbackTimestamp: {
        seconds: 1640767605,
        nanoseconds: 826000000,
    },
};

export const mockConfirmedBooking: Booking = {
    id: "fake-booking-id",
    calendarEventId: null,
    request: "fake-request-id",
    title: "Booking title",
    offeringCategory: "dining",
    member: "fake-member-id",
    createdBy: "Unit test",
    createdAt: {
        seconds: 1640767605,
        nanoseconds: 826000000,
    },
    archived: false,
    reviewNeeded: false,
    address: "Fake address",
    benefits: "Fake benefits",
    bookingPolicy: "Fake booking policy",
    catalogItem: "Fake catalog item id",
    country: "Fake country",
    croppedImageURL:
        "https://ik.imagekit.io/albertine/catalog/24/11/22/7681d1b2-98ab-49d6-8e46-d7e5e8cdafea.jpeg",
    description: "Fake descrription",
    endTimezone: "Asia/Tokyo",
    geoPoint: {
        latitude: 0,
        longitude: 0,
    },
    googleUrl: "Fake google url",
    headline: "Fake headline",
    imageURL:
        "https://ik.imagekit.io/albertine/catalog/24/11/22/7681d1b2-98ab-49d6-8e46-d7e5e8cdafea.jpeg",
    images: [
        {
            url: "https://ik.imagekit.io/albertine/catalog/24/11/22/7681d1b2-98ab-49d6-8e46-d7e5e8cdafea.jpeg",
            mimeType: "image/jpeg",
        },
    ],
    notesForMember: "Fake notes for member",
    notesForMemberSenderId: "Fake notes for member sender id",
    notesForMemberSenderName: "Fake notes for member sender name",
    paymentTo: "albertine",
    phoneNumber: "Fake phone numer",
    price: { currency: "EUR", amount: 100 },
    priceDetails: "Fake price details",
    priceQuote: "estimate",
    startTimezone: "Asia/Tokyo",
    supplierDetails: "Fake supplier details",
    suppliers: ["little-emperors"],
    website: "Fake website",
};

export const mockAgent: Agent = {
    id: "AlbertineServiceAgent",
    email: "test@albertineapp.com",
    firstName: "Albertine",
    name: "Albertine",
    role: "agent",
    disabled: false,
    createdAt: null,
    onboardingCallReservationUrl: null,
};
